import { FormType } from '@/__generated__/types';
import { FORM_TYPE_LABELS } from '@/constants/form';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface FormTypeBadgeProps {
    formType: FormType;
}

const FORM_TYPE_LABEL_COLORS = {
    [FormType.NewMerchant]: 'primary',
    [FormType.DemoRequest]: 'secondary',
    [FormType.Support]: 'warning',
    [FormType.Partnership]: 'success',
    [FormType.GeneralEnquiry]: 'default'
} as const satisfies Record<FormType, 'default' | 'primary' | 'secondary' | 'success' | 'warning'>;

export const FormTypeBadge = ({ formType }: FormTypeBadgeProps): JSX.Element => {
    const { t } = useTranslation();

    return (
        <Chip
            size="small"
            color={FORM_TYPE_LABEL_COLORS[formType]}
            label={t(`form.types.${formType}`, FORM_TYPE_LABELS[formType])}
            sx={{ minWidth: 108, fontWeight: 700 }}
        />
    );
};
